import { Card, Col, Row } from "react-bootstrap";

import { IError404Resources } from "./Error404.resources";
import { Link } from "react-router-dom";
import React from "react";
import { ServicoParagraphGreen } from "../../components/Servico/ServicoStyled";
import logo from "../../assets/images/logo-light.png";
import styled from "styled-components";
import { useTypedResource } from "../../i18n/languagehandler";

const ServicoCard = styled(Card)`
  background-color: ${(props) => props.theme.mainColor} !important;
`;

const StyledH3 = styled.h3`
  color: ${(props) => props.theme.secondColor} !important;
`;

const StyledLink = styled(Link)`
  color: ${(props) => props.theme.mainColor} !important;
`;

const Error404 = () => {
  const res = useTypedResource<IError404Resources>("error404");

  return (
    <React.Fragment>
      <div className="account-pages mt-5 mb-5">
        <div className="container">
          <Row className="justify-content-center">
            <Col lg={4}>
              <ServicoCard>
                <Card.Body className="p-4">
                  <div className="error-ghost text-center">
                    <img src={logo} alt="" className="logo-light" height="80" />
                  </div>

                  <div className="text-center">
                    <StyledH3 className="mt-4">{res.title}</StyledH3>
                    <ServicoParagraphGreen className="mt-4">
                      {res.subtitle()}
                    </ServicoParagraphGreen>
                  </div>
                </Card.Body>
              </ServicoCard>

              <Row>
                <Col className="text-center">
                  <p className="text-white-50">
                    <StyledLink to="/" className="text-white ms-1">
                      <b>{res.button}</b>
                    </StyledLink>
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>

      <footer className="footer footer-alt">2024 © servi.co</footer>
    </React.Fragment>
  );
};

export default Error404;
